import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { RefTypeInteraction } from 'src/app/data/intervenant/models/ref-type-interaction.model';
import { RefTypeInteractionsService } from 'src/app/data/intervenant/services/ref-type-interaction/ref-type-interactions.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-edit-type-interaction',
    templateUrl: './edit-type-interaction.component.html',
    styleUrls: ['./edit-type-interaction.component.scss'],
    standalone: false
})
export class EditTypeInteractionComponent implements OnInit {
    formGroup: UntypedFormGroup;
    creation = false;
    title: string;
    typeInteraction: RefTypeInteraction;

    get code() {
        return this.formGroup.get('code');
    }
    get libelle() {
        return this.formGroup.get('libelle');
    }

    constructor(
        private readonly fb: UntypedFormBuilder,
        private readonly loaderService: LoaderService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly typeInteractionsService: RefTypeInteractionsService
    ) {}

    ngOnInit() {
        const id = parseInt(this.route.snapshot.paramMap.get('id'), 10);

        if (!id) {
            this.creation = true;
        }
        this.loadData(id);
    }

    loadData(id: number) {
        this.title = this.creation ? 'page.valeur_parametrable.form.title.add_typeInteraction' : 'page.valeur_parametrable.form.title.edit_typeInteraction';

        if (this.creation) {
            this.typeInteraction = new RefTypeInteraction();
            this.initForm(null);
        } else {
            this.typeInteractionsService
                .getTypeInteractions()
                .pipe(this.loaderService.operator())
                .subscribe(typeInteractions => {
                    this.typeInteraction = typeInteractions.find(g => g.id === id);
                    this.initForm(this.typeInteraction && this.typeInteraction.id ? this.typeInteraction : null);
                });
        }
    }

    private initForm(typeInteraction?: RefTypeInteraction): void {
        this.formGroup = this.fb.group({
            code: [{ value: typeInteraction ? typeInteraction.code : undefined, disabled: false }, Validators.required],
            libelle: [{ value: typeInteraction ? typeInteraction.libelle : undefined, disabled: false }, Validators.required]
        });
    }

    submit() {
        if (this.formGroup.valid) {
            this.typeInteraction.code = this.code.value;
            this.typeInteraction.libelle = this.libelle.value;

            if (this.typeInteraction.id == null) {
                this.typeInteractionsService.creerTypeInteraction(this.typeInteraction).subscribe(idCultureBio => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            } else {
                this.typeInteractionsService.modifierTypeInteraction(this.typeInteraction).subscribe(() => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            }
        }
    }
}
